const SEO_GEO_CONTENT_SCHEMA = 'storage365.seo.geo-content';
const SEO_GEO_CONTENT_VERSION = 1;

const getDefaultBlock = () => ({
    type: 'text',
    text: ''
});

const normalizeTextBlock = block => ({
    type: 'text',
    text: block && typeof block.text === 'string' ? block.text : ''
});

const normalizeFaqBlock = block => ({
    type: 'faq',
    faqItems: Array.isArray(block && block.faqItems)
        ? block.faqItems
            .map(item => ({
                question: item && typeof item.question === 'string' ? item.question : '',
                answer: item && typeof item.answer === 'string' ? item.answer : ''
            }))
            .filter(item => item.question || item.answer)
        : (() => {
            const questions = Array.isArray(block && block.questions)
                ? block.questions.map(q => typeof q === 'string' ? q : '')
                : [];
            const answers = Array.isArray(block && block.answers)
                ? block.answers.map(a => typeof a === 'string' ? a : '')
                : [];
            const count = Math.max(questions.length, answers.length);

            return Array.from({ length: count })
                .map((_, index) => ({
                    question: questions[index] || '',
                    answer: answers[index] || ''
                }))
                .filter(item => item.question || item.answer);
        })()
});

const normalizeCtaBlock = block => ({
    type: 'cta',
    label: block && typeof block.label === 'string' ? block.label : '',
    url: block && typeof block.url === 'string' ? block.url : ''
});

const normalizeHeadingBlock = block => ({
	type: 'heading',
	level: block && ['h2', 'h3', 'h4', 'h5', 'h6'].includes(block.level) ? block.level : 'h2',
	text: block && typeof block.text === 'string' ? block.text : ''
});

const normalizeBlock = block => {
    if(!block || typeof block !== 'object') {
        return null;
    }

    switch(block.type) {
        case 'text':
            return normalizeTextBlock(block);
        case 'faq':
            return normalizeFaqBlock(block);
        case 'cta':
            return normalizeCtaBlock(block);
		case 'heading':
			return normalizeHeadingBlock(block);
        default:
            return null;
    }
};

export const parseSeoGeoContent = content => {
    if(!content || typeof content !== 'string') {
        return {
            isEnvelope: false,
            blocks: [],
            legacyText: ''
        };
    }

    try {
        const parsed = JSON.parse(content);

        if(
            parsed
            && typeof parsed === 'object'
            && parsed.schema === SEO_GEO_CONTENT_SCHEMA
            && parsed.version === SEO_GEO_CONTENT_VERSION
            && Array.isArray(parsed.blocks)
        ) {
            return {
                isEnvelope: true,
                blocks: parsed.blocks.map(normalizeBlock).filter(Boolean),
                legacyText: ''
            };
        }
    } catch (error) {
        // Backward compatibility: plain text content should not throw.
    }

    return {
        isEnvelope: false,
        blocks: [],
        legacyText: content
    };
};

export const serializeSeoGeoContent = blocks => {
    const normalizedBlocks = Array.isArray(blocks)
        ? blocks.map(normalizeBlock).filter(Boolean)
        : [];

    return JSON.stringify({
        schema: SEO_GEO_CONTENT_SCHEMA,
        version: SEO_GEO_CONTENT_VERSION,
        blocks: normalizedBlocks
    });
};

export const createInitialSeoGeoBlocks = content => {
    const parsed = parseSeoGeoContent(content);

    if(parsed.isEnvelope) {
        return parsed.blocks.length > 0 ? parsed.blocks : [ getDefaultBlock() ];
    }

    return [
        {
            type: 'text',
            text: parsed.legacyText || ''
        }
    ];
};

export const getDefaultSeoGeoBlock = getDefaultBlock;
